module.exports = __webpack_public_path__ + "img/养老美团首页banner.cea26f75.png";